import React, { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import LandscapeIndicatorBaseTemplate from '../../../templates/LandscapeIndicatorBaseTemplate';
import {
  TranslationOrganism,
  VerificationApproachOrganism,
} from '../../organisms';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import { PromiseSettledResult } from '../../../utils/types/types';

interface LandscapeIndicatorVerificationApproachTemplateProps {
  setLanguage: React.Dispatch<React.SetStateAction<LocalesLanguagesConstants>>;
  selectedLanguage: LocalesLanguagesConstants;
  fromLanguage: LocalesLanguagesConstants;
  setFromLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  toLanguage: LocalesLanguagesConstants;
  setToLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  generateTranslation: () => Promise<void>;
  generateAllTranslations: () => Promise<PromiseSettledResult<void>[]>;
  content: string;
  setContent: (content: string) => void;
  callbackFn: () => void;
  published: boolean;
  setPublished: (published: boolean) => void;
}

const LandscapeIndicatorVerificationApproachTemplate: FC<
  LandscapeIndicatorVerificationApproachTemplateProps
> = ({
  setLanguage,
  selectedLanguage,
  fromLanguage,
  setFromLanguage,
  toLanguage,
  setToLanguage,
  generateTranslation,
  generateAllTranslations,
  content,
  setContent,
  callbackFn,
  published,
  setPublished,
}) => {
  return (
    <BaseTemplate>
      <Container>
        <LandscapeIndicatorBaseTemplate>
          <TranslationOrganism
            setLanguage={setLanguage}
            selectedLanguage={selectedLanguage}
            fromLanguage={fromLanguage}
            setFromLanguage={setFromLanguage}
            toLanguage={toLanguage}
            setToLanguage={setToLanguage}
            generateTranslation={generateTranslation}
            generateAllTranslations={generateAllTranslations}
          />
          <VerificationApproachOrganism
            content={content}
            setContent={setContent}
            callbackFn={callbackFn}
            published={published}
            setPublished={setPublished}
          />
        </LandscapeIndicatorBaseTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeIndicatorVerificationApproachTemplate;
